const REQUIRES_REAPPROVAL_STATUSES = ["Denied", "Inactive", "Rejected", "Submitted"];
const REQUIRES_REAPPROVAL_VERIFY_STATUSES = ["Denied", "Rejected"];

export const wasPreviouslyApproved = (property = {}) => {
	const currentStatus = property?.status || property?.Status || "Draft";
	const verifyStatus = property?.verifyStatus || property?.VerifyStatus;

	if (REQUIRES_REAPPROVAL_STATUSES.includes(currentStatus)) {
		return false;
	}

	if (REQUIRES_REAPPROVAL_VERIFY_STATUSES.includes(verifyStatus)) {
		return false;
	}

	const approvedBy = property?.approvedBy || property?.ApprovedBy;
	const comment = (property?.comment || property?.Comment || "").trim().toLowerCase();
	const hasApprovalComment = comment === "approved" || comment === "auto approved";

	return (
		currentStatus === "Active"
		|| verifyStatus === "Active"
		|| (approvedBy && approvedBy !== "NA")
		|| hasApprovalComment
	);
};

export const resolvePropertyStatus = ({
	property,
	isConfirm,
	isEmployee,
	isVerifiedEmployee,
}) => {
	const currentStatus = property?.status || property?.Status || "Draft";
	const hasExistingProperty = !!property;
	const isPreviouslyApproved = wasPreviouslyApproved(property);

	if (!hasExistingProperty) {
		if (!isConfirm) return "Draft";
		if (!isEmployee) return "Submitted";
		return isVerifiedEmployee ? "Active" : "Draft";
	}

	if (!isConfirm) {
		return "Draft";
	}

	if ((currentStatus === "Denied" || currentStatus === "Inactive") && !isEmployee) {
		return "Submitted";
	}

	if (currentStatus === "Draft" && isPreviouslyApproved) {
		return "Active";
	}

	if (isPreviouslyApproved && !isEmployee) {
		return "Active";
	}

	if (currentStatus === "Active") {
		return "Active";
	}

	if (currentStatus === "Draft" && !isEmployee) {
		return "Submitted";
	}

	if (currentStatus === "Draft" && isVerifiedEmployee) {
		return "Active";
	}

	return currentStatus;
};

export const resolveApprovalComment = ({ property, finalStatus, isEmployee }) => {
	const hasPriorApproval = wasPreviouslyApproved(property);
	const existingComment = property?.comment || property?.Comment;

	if (finalStatus === "Submitted") {
		return undefined;
	}

	if (finalStatus !== "Active") {
		return existingComment || undefined;
	}

	if (hasPriorApproval) {
		return "Auto Approved";
	}

	return isEmployee ? "Approved" : (existingComment || undefined);
};

export const getApprovalMetadata = (property = {}, fallbackApprovedBy, { finalStatus, isEmployee } = {}) => {
	const isPreviouslyApproved = wasPreviouslyApproved(property);
	const comment = finalStatus !== undefined
		? resolveApprovalComment({ property, finalStatus, isEmployee })
		: (property?.comment || property?.Comment || (isPreviouslyApproved ? "Auto Approved" : undefined));

	if (finalStatus === "Submitted") {
		return {
			VerifyStatus: undefined,
			ApprovedBy: "NA",
			Comment: comment,
		};
	}

	return {
		VerifyStatus: property?.verifyStatus || property?.VerifyStatus || (isPreviouslyApproved ? "Active" : undefined),
		ApprovedBy: property?.approvedBy || property?.ApprovedBy || (isPreviouslyApproved ? fallbackApprovedBy : undefined),
		Comment: comment,
	};
};